'use client';

import type { MouseEvent } from 'react';

import { usePageLayout } from '@libs/common-next';
import { handleServiceClick, isServicesLink } from '@libs/experience-api';

type ServicesLinkClickOptions = {
    event: MouseEvent;
    link?: string;
    shouldOpenInNewTab?: boolean;
};

function shouldOpenServicesInNewTab(event: MouseEvent, shouldOpenInNewTab?: boolean) {
    return Boolean(shouldOpenInNewTab || event.metaKey || event.ctrlKey || event.shiftKey);
}

export function useServicesLinkClick() {
    const { isAuthenticated } = usePageLayout();

    return ({ event, link, shouldOpenInNewTab }: ServicesLinkClickOptions) => {
        if (!isAuthenticated || !isServicesLink(link)) {
            return;
        }

        void handleServiceClick({
            authType: isAuthenticated,
            event,
            link,
            shouldOpenInNewTab: shouldOpenServicesInNewTab(event, shouldOpenInNewTab),
        });
    };
}
